import { Container, Modal } from 'react-bootstrap';
import { FC } from 'react';
import { helpers, telephonicServices } from 'src/services';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { Hr } from 'src/components/_commons';
import { typeTelephonicTerritory } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    closeModal: () => void;
    t: typeTelephonicTerritory;
};

export const TelephonicResetModal: FC<propsType> = ({ closeModal, t }) => {
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    const resetHandler = async (selectedOption: 1 | 2 | 3 | 4): Promise<void> => {
        if (!selectedOption) {
            return;
        }
        let message = '';
        if (selectedOption === 1) {
            message = 'Esta opción resetea los predicados más viejos (más de 6 meses) pero deja los no abonados como están';
        } else if (selectedOption === 2) {
            message = 'Esta opción resetea todos los predicados pero deja los no abonados como están';
        } else if (selectedOption === 3) {
            message = 'Esta opción resetea los predicados y no abonados más viejos (de más de 6 meses)';
        } else {
            message = 'Esta opción resetea todos los predicados y los no abonados';
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: `¿Resetear Territorio ${t.territoryNumber}?`,
            message,
            execution: async () => {
                if (!selectedOption) {
                    return;
                }
                dispatch(showLoadingModalReducer());
                const response = await telephonicServices.ResetTerritory(t.territoryNumber, selectedOption);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                dispatch(setValuesAndOpenAlertModalReducer({
                    mode: 'alert',
                    title: 'Terminado',
                    message: `Se resetearon las viviendas usando la opción ${selectedOption}`,
                    // execution: () => window.location.reload(),
                    animation: 1
                }));
            }
        }));
    }

    return (
        <Modal show size={'lg'} fullscreen={'md-down'} onHide={closeModal}>
            <Modal.Header className={isDarkMode ? 'bg-dark text-white' : ''} closeButton>
                <Modal.Title>
                    Reseteos del territorio {t.territoryNumber}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark' : ''}>
                <Container className={'mb-2'} style={{ maxWidth: '600px' }}>
                    {!!t.stateOfTerritory.resetDates.length &&
                        <div className={`${isDarkMode ? 'text-white' : ''} my-4`}>
                            {t.stateOfTerritory.resetDates.map(reset =>
                                <h5 key={reset.date}>
                                    &nbsp; -El {helpers.TimeConverter(reset.date)} con la opción {reset.option}
                                </h5>
                            )}
                        </div>
                    }
                    <Hr />
                    <div className={'container mt-4'}>
                        <button className={'btn btn-general-red w-100 mb-2 py-3'}
                            onClick={() => resetHandler(1)}
                        >
                            Resetear los de más de 6 meses menos los no abonados
                        </button>
                        <button className={'btn btn-general-red w-100 mb-2 py-3'}
                            onClick={() => resetHandler(2)}
                        >
                            Resetear todos menos los no abonados
                        </button>
                        <button className={'btn btn-general-red w-100 mb-2 py-3'}
                            onClick={() => resetHandler(3)}
                        >
                            Resetear los de más de 6 meses incluso los no abonados
                        </button>
                        <button className={'btn btn-general-red w-100 mb-2 py-3'}
                            onClick={() => resetHandler(4)}
                        >
                            Resetear absolutamente todos
                        </button>
                    </div>
                </Container>
            </Modal.Body>
        </Modal>
    );
}
